export function getEnv(): string {
	const host = window.location.hostname.split('.')

	if (host.find((x) => x === Environments.DEV || x.includes(Environments.LOCAL))) return Environments.DEV
	if (host.find((x) => x === Environments.INT)) return Environments.INT
	if (host.find((x) => (x === Environments.UAT && host.length === 4) || (x.includes('test') && host.length === 2)))
		return Environments.UAT

	return Environments.PROD
}

export function isProdOrUat(): boolean {
	return getEnv() === Environments.PROD || getEnv() === Environments.UAT
}

export enum Environments {
	LOCAL = 'local',
	DEV = 'dev',
	INT = 'int',
	PROD = 'prod',
	UAT = 'test',
}
